import { render } from "./CreditsGraphics.vue?vue&type=template&id=2bca139f"
import script from "./CreditsGraphics.vue?vue&type=script&lang=js"
export * from "./CreditsGraphics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__